module.exports = __webpack_public_path__ + "fonts/loading.8732a6660b528fadfaeb35bcf568875f.gif?";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/images/loading.gif
// module id = 910
// module chunks = 6